import {getTextByValue} from "../../Utilities/Types/listUtilities";
import {ORDER_STATUS, ORDER_STATUS_LIST, ORDER_TYPE_LIST} from "./orderConstants";
import {FORMAT_LIST} from "../Library/libraryConstants";

export const getOrderTypeTextByValue = (value: string | number = "") => getTextByValue(ORDER_TYPE_LIST, value);

export const getOrderStatusTextByValue = (value: string | number = "") => getTextByValue(ORDER_STATUS_LIST, value);
export const getFormatTextByValue = (value: string | number = "") => getTextByValue(FORMAT_LIST, value);

export const getButtonLabelFromOrderStatus = (orderStatus: string | number) => {
    const label =`Is the following step complete, `;
    switch (orderStatus.toString()) {
        case ORDER_STATUS.PartialOrderReceived.id :
            return label + getOrderStatusTextByValue(ORDER_STATUS.PartialOrderReceived.id);
        case ORDER_STATUS.FullOrderReceived.id:
            return label + getOrderStatusTextByValue(ORDER_STATUS.FullOrderReceived.id);
        case ORDER_STATUS.AddToCatalogInventory.id:
            return label + getOrderStatusTextByValue(ORDER_STATUS.PrintBarcode.id);
        case ORDER_STATUS.PrintBarcode.id:
            return label + getOrderStatusTextByValue(ORDER_STATUS.PrintMailingLabel.id);
        case ORDER_STATUS.PrintMailingLabel.id:
            return label + getOrderStatusTextByValue(ORDER_STATUS.ReadyToMail.id);
        case ORDER_STATUS.ReadyToMail.id:
            return label + getOrderStatusTextByValue(ORDER_STATUS.Mailed.id);
        case ORDER_STATUS.ShelveVolumes.id:
            return label + getOrderStatusTextByValue(ORDER_STATUS.ShelveVolumes.id);
    }
}